import { ANALYTICS } from '../../constants/common';
import { trackFormInput, trackFormWorkFlow } from './analyticEvents';

/**
 * @method trackFileUploadInitiate
 * @description this method tracks the file upload initiation
 * @param {string} formName (form name) [name of the form]
 */
export const trackFileUploadInitiate = (formName: string) => {
  trackFormWorkFlow(
    formName,
    ANALYTICS.FORM_ACTION.INITIATED,
    ANALYTICS.STEP,
    ANALYTICS.PAGE_LOAD,
    ''
  );
};

/**
 * @method trackFileUploadComplete
 * @description this method tracks the file upload complete
 * @param {string} formName (form name) [name of the form]
 */
export const trackFileUploadComplete = (formName: string) => {
  trackFormWorkFlow(
    formName,
    ANALYTICS.FORM_ACTION.COMPLETED,
    ANALYTICS.STEP,
    ANALYTICS.PAGE_LOAD,
    ''
  );
};

/**
 * @method trackFileUploadError
 * @description this method tracks the file upload error
 * @param {string} formName (form name) [name of the form]
 */
export const trackFileUploadError = (formName: string) => {
  trackFormWorkFlow(
    formName,
    ANALYTICS.FORM_ACTION.ERROR,
    ANALYTICS.STEP,
    ANALYTICS.PAGE_LOAD,
    ''
  );
};

/**
 * @method trackfileUploadUsage
 * @description tracks the usage of file upload feature
 * @param {string} formName (form name) [name of the form]
 * @param {string} userEncodedNtid (user encoded ntid ) [user encoded ntid]
 */
export const trackfileUploadUsage = (
  fromName: string,
  userEncodedNtid: string
) => {
  // track user encode ntid
  if (userEncodedNtid !== '') {
    trackFormInput(
      fromName,
      ANALYTICS.NUMBER_ONE,
      ANALYTICS.USER_ENCODED_NTID_QUESTION_NAME,
      userEncodedNtid,
      '1'
    );
  }
};

/**
 * @method trackFileRepoLimitReached
 * @description tracks when the file repository limit is reached
 */
export const trackFileRepoLimitReached = () => {
  trackFormInput(
    ANALYTICS.FILE_UPLOAD_FORM_NAME,
    ANALYTICS.NUMBER_ONE,
    ANALYTICS.REPOSITORY_LIMIT_REACHED_QUESTION_NAME,
    ANALYTICS.YES,
    '1'
  );
};

/**
 * @method trackFileUploadSize
 * @description tracks the file upload size
 * @param {string} fileSize (file size) [size of the uploaded file]
 */
export const trackFileUploadSize = (fileSize: string) => {
  trackFormInput(
    ANALYTICS.FILE_UPLOAD_FORM_NAME,
    ANALYTICS.NUMBER_ONE,
    ANALYTICS.FILE_UPLOAD_SIZE_QUESTION_NAME,
    fileSize,
    '1'
  );
};

/**
 * @method trackFriendlyFileNameEdit
 * @description tracks when a friendly file name is edited
 */
export const trackFriendlyFileNameEdit = () => {
  trackFormInput(
    ANALYTICS.FILE_UPLOAD_FORM_NAME,
    ANALYTICS.NUMBER_ONE,
    ANALYTICS.FRIENDLY_FILE_NAME_EDIT_QUESTION_NAME,
    ANALYTICS.YES,
    '1'
  );
};

/**
 * @method trackFileDelete
 * @description tracks when a file is deleted
 */
export const trackFileDelete = () => {
  trackFormWorkFlow(
    ANALYTICS.FILE_DELETE_FORM_NAME,
    ANALYTICS.FORM_ACTION.INITIATED,
    ANALYTICS.STEP,
    ANALYTICS.PAGE_LOAD,
    ''
  );
};

/**
 * @method trackFileDownload
 * @description tracks when a file is downloaded
 */
export const trackFileDownload = () => {
  trackFormWorkFlow(
    ANALYTICS.FILE_DOWNLOAD_FORM_NAME,
    ANALYTICS.FORM_ACTION.INITIATED,
    ANALYTICS.STEP,
    ANALYTICS.PAGE_LOAD,
    ''
  );
};
